// Module
var code = "<svg width=\"9\" height=\"16\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 16\"><path d=\"M7.75 15.5c-.313 0-.627-.12-.865-.359L.359 8.615a1.222 1.222 0 010-1.73L6.885.359a1.222 1.222 0 111.73 1.73l-5.66 5.66 5.66 5.663A1.222 1.222 0 017.75 15.5\" fill-rule=\"evenodd\"/></svg> ";
// Exports
module.exports = code;